import { INITIAL_STATE_LOADED } from "EmployerApplication/Actions";
import _ from "underscore";

import { ADD_PLAN_TO_CART, ADD_UPGRADE_OPTION, REMOVE_UPGRADE_OPTION, ADD_PACKAGE_TO_CART, UPDATE_CART_RELATED_PLAN_IDS } from "./Actions";
// TODO-SI-7651
export function cart(state = {}, action) {
  switch (action.type) {
    case INITIAL_STATE_LOADED:
      return action.payload.cart;

    case ADD_PLAN_TO_CART:
      var newCart = _.clone(state);

      var planID = null;

      if (action.planType === "medical") {
        if (Array.isArray(action.planID)) {
          planID = action.planID;
        } else {
          planID = Array(action.planID);
        }

        if (action.shouldClearDentalVision) {
          if (newCart.dental !== null || newCart.vision !== null) {
            newCart.clearedDentalVision = true;
          }

          newCart.dental = null;
          newCart.vision = null;
        }

        if (action.shouldClearLife) {
          if (newCart.life !== null) {
            newCart.clearedLife = true;
          }

          newCart.life = null;
        }
      } else {
        planID = action.planID;
        newCart.clearedDentalVision = false;
        newCart.clearedLife = false;
      }

      newCart[action.planType] = planID;
      return newCart;

    case ADD_UPGRADE_OPTION:
      // Upgrade Options are always medical plans.
      // It should not clear any medical plans already in the cart.
      return { ...state, medical: _.uniq([...state.medical, action.planID]) };

    case REMOVE_UPGRADE_OPTION:
      return {
        ...state,
        medical: state.medical.filter((pID) => pID !== action.planID),
      };

    case ADD_PACKAGE_TO_CART:
      return { ...state, medical: action.planIds };

    default:
      return state;
  }
}
export function relatedCartPlanIds(state = [], action) {
  switch (action.type) {
    case UPDATE_CART_RELATED_PLAN_IDS:
      return action.relatedCartPlanIds;

    default:
      return state;
  }
}
